import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, Button, FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { listarCursos } from '../../services/cursoService';

const FormDisciplina = ({ onSubmit, disciplinaInicial = null, isLoading = false }) => {
  const [disciplina, setDisciplina] = useState({
    nome: '',
    cursoId: '',
  });
  const [cursos, setCursos] = useState([]);
  const [loadingCursos, setLoadingCursos] = useState(true);

  useEffect(() => {
    const fetchCursos = async () => {
      try {
        const cursosData = await listarCursos();
        setCursos(cursosData);
      } catch (error) {
        console.error('Erro ao carregar cursos:', error);
      } finally {
        setLoadingCursos(false);
      }
    };

    fetchCursos();
  }, []);

  useEffect(() => {
    if (disciplinaInicial) {
      setDisciplina(prevState => ({
        ...prevState,
        ...disciplinaInicial
      }));
    }
  }, [disciplinaInicial]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDisciplina(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(disciplina);
  };

  if (loadingCursos) {
    return <CircularProgress />;
  }

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        fullWidth
        label="Nome da Disciplina"
        name="nome"
        value={disciplina.nome}
        onChange={handleChange}
        margin="normal"
        required
      />
      <FormControl fullWidth margin="normal" required>
        <InputLabel id="curso-label">Curso</InputLabel>
        <Select
          labelId="curso-label"
          name="cursoId"
          value={disciplina.cursoId}
          onChange={handleChange}
          label="Curso"
        >
          {cursos.map((curso) => (
            <MenuItem key={curso.id} value={curso.id}>
              {curso.nome}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button 
        type="submit" 
        variant="contained" 
        color="primary" 
        sx={{ mt: 2 }}
        disabled={isLoading}
      >
        {isLoading ? <CircularProgress size={24} /> : (disciplinaInicial?.id ? 'Atualizar Disciplina' : 'Criar Disciplina')}
      </Button>
    </form>
  );
};

FormDisciplina.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  disciplinaInicial: PropTypes.shape({
    nome: PropTypes.string,
    cursoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.number,
  }),
  isLoading: PropTypes.bool,
};

export default FormDisciplina;
